import React from 'react';
import {Provider} from 'react-redux';
import {createPortal} from 'react-dom';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router';
import {AppContainer} from './app/AppContainer';
import {Head} from './head';
import './index.css';
import {configureMuiPro} from './license/datagrid-pro';
import {configureLocalization} from './localization';
import {
  configureAssertLogging,
  configureLoggingOfUnhandledPromiseRejections,
  initLogging,
  logWarning,
} from './logging';
import configureStore from './store/configureStore';

initLogging();
configureAssertLogging();
configureLoggingOfUnhandledPromiseRejections();
configureLocalization({logWarning});
configureMuiPro();

const {store, persistor} = configureStore;

const appContainer = document.getElementById('root');
if (!appContainer) {
  throw new Error('No root element found');
}
const root = createRoot(appContainer);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppContainer store={store} persistor={persistor} />
    </BrowserRouter>
  </React.StrictMode>,
);

const head = document.getElementsByTagName('head').item(0);
if (!head) {
  throw new Error('No head element found');
}
const headContainer = document.createElement('head');
const headRoot = createRoot(headContainer);
headRoot.render(
  createPortal(
    <Provider store={store}>
      <Head />
    </Provider>,
    head,
  ),
);
